import React from "react"
import PropTypes from "prop-types"
import {
  LoaderIcon,
  FullWidthImageSection,
  PaginationSelector,
  SearchInput,
  Heading
} from "components"
import { withSearch, withRadium, DetectCompact, gtmEvent } from "higher-order-components"
import { BASE_COPY } from "constants/general-style"
import COLOR_PALETTE from "constants/color-palette"
import { gtmSearchActionTypes } from "store/gtm-events"

import SearchResultItem from "./search-result-item"

const getResultRange = (currentPage, resultsPerPage, totalHits) => {
  const from = (currentPage - 1) * resultsPerPage
  const to = currentPage * resultsPerPage
  return `${from + 1} - ${to > totalHits ? totalHits : to}`
}

const SiteSearchContainer = ({
  heading,
  backgroundImageUrl,
  searchFieldPlaceholderText,
  updateSearchQuery,
  requestPage,
  gtmEvent,
  compact,
  searchResultsData: {
    resultsPerPage,
    error,
    currentPage,
    results,
    totalHits,
    totalPage,
    isFetching
  },
  query
}) => (
  <div style={{ position: "relative", overflow: "hidden", minHeight: "calc(100vh - 100px)"}}>
    <FullWidthImageSection
      height={"fit"}
      fullWidth
      backgroundImage={backgroundImageUrl}>
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        <Heading tag="h3" value={heading} />
        <form onSubmit={(e)=>{e.preventDefault()}}>
          <SearchInput
            styleName={"dark"}
            onSearch={(q) => {
              if (q.length) {
                gtmEvent({
                  gtmID: gtmSearchActionTypes.SITE_SEARCH_RESULTS,
                  gtmPayload: { query: q }
                })
                updateSearchQuery(q)
              }
            }}
            initialValue={query}
            placeholder={searchFieldPlaceholderText} />
        </form>
      </div>
    </FullWidthImageSection>
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "2em 1em" }}>
      {error ? (
        <p style={styles.error}>{error}</p>
      ) : (
        <div>
          {isFetching ? (
            <div>
              <LoaderIcon />
            </div>
          ) : (
            <div>
              {!!query.length &&
                      (totalHits ? (
                        <p style={styles.message}>
                          Showing{" "}
                          <strong style={{ fontWeight: 400 }}>
                            {getResultRange(currentPage, resultsPerPage, totalHits)}
                          </strong>{" "}
                          of <strong style={{ fontWeight: 400 }}>{totalHits}</strong> results for "<strong style={{ fontWeight: 400 }}>{query}</strong>"
                        </p>
                      ) : (
                        <p style={styles.message}>
                            No results for "<strong style={{ fontWeight: 400 }}>{query}</strong>"
                        </p>
                      ))}
              {results &&
                      results.map(({ title, excerpt, url }, index) => (
                        <SearchResultItem
                          highlight={query.split(" ")}
                          key={`${currentPage}-${(title || "")
                            .replace(/(\s|\_|\|)/g, "-")
                            .toLowerCase()}-${index}`} // eslint-disable-line react/no-array-index-key
                          href={url}
                          title={title}
                          description={excerpt}
                          animationDelay={index * 0.1}
                          gtmEvents={[
                            {
                              func: gtmEvent,
                              args: [
                                {
                                  gtmID: gtmSearchActionTypes.SITE_SEARCH_RESULTS_CLICKED,
                                  gtmPayload: { query: query, clicked: title }
                                }
                              ]
                            }
                          ]} />
                      ))}
            </div>
          )}
          {!isFetching &&
                results &&
                totalPage > 1 && (
              <div style={styles.pagesSection}>
                <PaginationSelector
                  onClickNumber={page => requestPage(page)}
                  onClickNext={() => requestPage(currentPage + 1)}
                  onClickBack={() => requestPage(currentPage - 1)}
                  maxDisplay={compact ? 3 : 5}
                  current={currentPage}
                  count={totalPage} />
              </div>
            )}
        </div>
      )}
    </div>
  </div>
)

SiteSearchContainer.propTypes = {
  updateSearchQuery: PropTypes.func,
  requestPage: PropTypes.func,
  searchResultsData: PropTypes.shape({
    hits: PropTypes.array,
    totalHits: PropTypes.number,
    totalPage: PropTypes.number,
    isFetching: PropTypes.bool
  }),
  query: PropTypes.string,
  heading: PropTypes.string,
  searchFieldPlaceholderText: PropTypes.string,
  backgroundImageUrl: PropTypes.string
}

export default withRadium(DetectCompact(), gtmEvent(), withSearch())(SiteSearchContainer)

const styles = {
  error: {
    ...BASE_COPY,
    textAlign: "center",
    color: COLOR_PALETTE.RED
  },
  pagesSection: {
    textAlign: "center",
    padding: "3em 0 1em",
    borderTop: `1px solid ${COLOR_PALETTE.GRAY}`
  },
  message: {
    ...BASE_COPY
  }
}



// WEBPACK FOOTER //
// ./src/containers/site-search/index.jsx